import React from 'react';

export const Card = ({
  children,
  className,
  style,
  ...rest
}: {
  children: any;
  className?: string;
  style?: any;
}) => {
  return (
    <div
      className={`bg-background rounded-md p-4 lg:p-8 ${className}`}
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
};

